import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_mst_location_ext_RowClass} from '../../../dbschema';

export class LocationExtensionContainerModel extends BaseContainerModel {
  bl_inv_mst_location_ext: bl_inv_mst_location_ext_RowClass = new bl_inv_mst_location_ext_RowClass();
}
